import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultGetActionAttributes = function defaultGetActionAttributes(action) {
  return action.attributes;
};
var defaultGetActionDisabled = function defaultGetActionDisabled(action) {
  return action.disabled;
};
var defaultGetActionIcon = function defaultGetActionIcon(action) {
  return action.icon;
};
var defaultGetActionLabel = function defaultGetActionLabel(action) {
  return action.label;
};
var defaultGetActionOnClick = function defaultGetActionOnClick(action) {
  return action.onClick;
};
var defaultGetActionRef = function defaultGetActionRef(action) {
  return action.ref;
};
var defaultGetActionTagName = function defaultGetActionTagName(action) {
  return action.tagName;
};
var defaultGetButtonAttributes = function defaultGetButtonAttributes(button) {
  return button.attributes;
};
var defaultGetButtonDisabled = function defaultGetButtonDisabled(button) {
  return button.disabled;
};
var defaultGetButtonLabel = function defaultGetButtonLabel(button) {
  return button.label;
};
var defaultGetButtonOnClick = function defaultGetButtonOnClick(button) {
  return button.onClick;
};
var defaultGetButtonRef = function defaultGetButtonRef(button) {
  return button.ref;
};
var defaultGetButtonTagName = function defaultGetButtonTagName(button) {
  return button.tagName;
};
export var composePreparedProps = function composePreparedProps(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    actionGetters: {
      getActionAttributes: props.getActionAttributes || defaultGetActionAttributes,
      getActionDisabled: props.getActionDisabled || defaultGetActionDisabled,
      getActionIcon: props.getActionIcon || defaultGetActionIcon,
      getActionLabel: props.getActionLabel || defaultGetActionLabel,
      getActionOnClick: props.getActionOnClick || defaultGetActionOnClick,
      getActionRef: props.getActionRef || defaultGetActionRef,
      getActionTagName: props.getActionTagName || defaultGetActionTagName
    },
    buttonGetters: {
      getButtonAttributes: props.getButtonAttributes || defaultGetButtonAttributes,
      getButtonDisabled: props.getButtonDisabled || defaultGetButtonDisabled,
      getButtonLabel: props.getButtonLabel || defaultGetButtonLabel,
      getButtonOnClick: props.getButtonOnClick || defaultGetButtonOnClick,
      getButtonRef: props.getButtonRef || defaultGetButtonRef,
      getButtonTagName: props.getButtonTagName || defaultGetButtonTagName
    }
  });
};